<template>
    <div class="contacts-component__inner">
        <ul class="filter">
            <li class="filter__item" v-if="countries.length > 0 && !prefilterCountry">
                <label for="countryFilter" class="sr-only">{{ dictionary.ContactsCountrySelectLabel
                    }}</label>
                <select id="countryFilter" v-model="country" :disabled="isLoading">
                    <option value="All">{{ dictionary.ContactsCountrySelectLabel }}</option>
                    <option v-for="countryItem in countries" :key="countryItem.Key" :value="countryItem.Key">{{
                        countryItem.Name
                        }}</option>
                </select>
            </li>
            <li class="filter__item"
                v-if="states.length > 0 && countries.find(x => x.Key == country)?.ShowNext || states.length > 0 && prefilterCountry?.ShowNext">
                <label for="stateFilter" class="sr-only">{{ dictionary.ContactsStateSelectLabel }}</label>
                <select id="stateFilter" v-model="state" :disabled="isLoading">
                    <option value="All">{{ dictionary.ContactsStateSelectLabel }}</option>
                    <option v-for="stateItem in states" :key="stateItem.Key" :value="stateItem.Key">{{ stateItem.Name }}
                    </option>
                </select>
            </li>
            <li class="filter__item" v-if="hasFilterApplied">
                <button type="button" @click="resetFilter"><span>{{ dictionary.ContactsResetFilter }}</span></button>
            </li>
        </ul>
        <div class="contacts-component__hr"></div>
        <ul class="contacts-component__list">
            <li class="contacts-component__list-item" v-for="contact in contacts" :key="contact.Id">
                <div class="contact">
                    <p class="contact__name">{{ contact.Name }}</p>
                    <div class="contact__info">
                        <p class="contact__info-info" v-if="contact.HasInfo">{{ contact.Info }}</p>
                        <p class="contact__info-additional" v-if="contact.HasAdditionalInfo">{{ contact.AdditionalInfo
                            }}</p>
                    </div>
                    <address class="contact__address"
                        v-if="contact.HasAddress || contact.HasZipCode || contact.HasCity">
                        {{ contact.Address }} <br v-if="contact.HasAddress" />
                        {{ contact.ZipCode }} {{ contact.City }}
                    </address>
                    <p class="contact__link" v-if="contact.HasPhone"><a :href="'tel:' + contact.Phone">{{ contact.Phone
                            }}</a></p>
                    <p class="contact__link" v-if="contact.HasEmail"><a :href="'mailto:' + contact.Email"
                            @click="handleEmailClick(contact.Email)">{{
                                contact.Email }}</a></p>
                    <p class="contact__link" v-if="contact.HasWebsite"><a :href="contact.Website.Url"
                            :target="contact.Website.Target">{{ contact.Website.Name }}</a></p>
                </div>
            </li>

        </ul>
        <div class="contacts-component__footer">
            <div class="contacts-component__load-more" v-show="hasMoreContacts && !showDefaults">
                <a @click="getNextPage" :disabled="isLoading">{{
                    dictionary.ContactsLoadMore
                    }}</a>
            </div>
        </div>
    </div>
</template>

<script>
import { bindRoute } from "./mixins/bindroute.js";

const serviceUrl = "/umbraco/api/contactsapi/getContacts",
    defaultCountry = "All",
    defaultState = "All";
export default {
    name: "contacts",
    props: ['prefilterCountry', 'defaultContacts'],
    data() {
        return {
            dictionary: [],
            countries: [],
            states: [],
            contacts: [],
            pageSize: 3,
            page: 1,
            totalContacts: 0,
            loadedContacts: 0,
            isLoading: false,
            hasLoadedInitials: false,
            isResetting: false,
            showDefaults: false
        };
    },
    mixins: [
        bindRoute({
            country: defaultCountry,
            state: defaultState,
        }),
    ],
    watch: {
        country: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        state: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        }
    },
    mounted() {
        this.$router.isReady().then(() => {
            this.getInitialContacts();
        }).catch(error => {
            console.log(error);
        });
    },
    methods: {
        handleEmailClick(email) {
            const currentUrl = window.location.origin + this.$route.fullPath + "?" + email;
            window.track_load(currentUrl, email)
        },
        handleFilterPropertyChange(oldVal, newVal) {
            if (oldVal !== newVal) {
                if (this.hasLoadedInitials && !this.isResetting) {
                    this.filterChanged();
                }
            }
        },
        getContacts(amountToSkip, pageSize) {
            const vm = this,
                languageCode = document.querySelector("html").getAttribute("lang");
            vm.toggleSpinner(true);
            var object = {
                languageCode: languageCode,
                amountToSkip: amountToSkip,
                pageSize: pageSize,
            };

            if (vm.prefilterCountry) {
                object.country = vm.prefilterCountry.Key;
            } else if (vm.country != defaultCountry) {
                object.country = vm.country;
            }

            if (vm.state != defaultState) {
                object.state = vm.state;
            }

            fetch(serviceUrl + "?" + new URLSearchParams(object))
                .then((response) => response.json())
                .then((data) => {
                    vm.dictionary = data.Dictionary;
                    vm.countries = data.Facets.Countries;
                    vm.states = data.Facets.States;
                    vm.contacts.push(...data.Items);
                    vm.loadedContacts += data.Items.length;
                    vm.totalContacts = data.TotalItems;
                    vm.showDefaults = false;

                    if ((!vm.hasLoadedInitials || vm.isResetting) && vm.defaultContacts) {
                        vm.contacts = vm.defaultContacts;
                        vm.showDefaults = true;
                    }

                    vm.hasLoadedInitials = true;
                    vm.toggleSpinner(false);
                    vm.isResetting = false;
                })
                .catch((error) => {
                    console.log(error);
                    vm.toggleSpinner(false);
                });
        },
        getNextPage() {
            if (!this.isLoading) {
                this.page++;
                this.getContacts(this.pageSize * (this.page - 1), this.pageSize);
            }
        },
        getInitialContacts() {
            let initialPageSize = this.pageSize;
            if (this.prefilterCountry || (this.country != defaultCountry && this.states != defaultState)) {
                initialPageSize = this.pageSize * this.page;
            }
            this.getContacts(0, initialPageSize);
        },
        filterChanged() {
            this.contacts = [];
            this.totalContacts = 0;
            this.loadedContacts = 0;
            this.page = 1;
            this.getContacts(0, this.pageSize);
        },
        resetFilter() {
            const vm = this;
            vm.isResetting = true;
            vm.contacts = [];
            vm.totalContacts = 0;
            vm.loadedContacts = 0;
            vm.page = 1;
            vm.country = defaultCountry;
            vm.state = defaultState;

            vm.$router.replace({ path: window.location.pathname, query: {} })
                .then(() => {
                    vm.getInitialContacts();
                })
                .catch(err => { console.log(err); });
        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;
            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        },
    },
    computed: {
        hasMoreContacts() {
            return (
                this.totalContacts !== 0 &&
                this.contacts.length < this.totalContacts &&
                (this.country != defaultCountry || this.prefilterCountry != null)
            );
        },
        hasFilterApplied() {
            return this.state != defaultState ||
                this.country != defaultCountry;
        }
    },
};
</script>